export enum TipoOrdem {
  ACAO = 'ACAO',
  BAIXA = 'BAIXA',
  HISTORICO = 'HISTORICO',
  CEND = 'CEND',
  REVOGACAO = 'REVOGACAO',
  OUTROS = 'OUTROS',
  _ATUALIZACAO_ACAO = 'ATUALIZACAO_ACAO'
}
